<template>
  <div>
    <v-card class="c-result-card pa-4 mb-4" elevation="4">

      <!-- summary -->
      <v-card-title class="d-flex justify-center pt-0 pb-3 px-2">
        <v-icon v-if="score >= passingGrade" color="success" x-large>
          mdi-check-circle
        </v-icon>
        <v-icon v-else color="error" x-large>
          mdi-alpha-x-circle
        </v-icon>
        <div class="c-score">
          {{ $t('quiz.status.score') }} {{ formattedScore() }} / {{ quizLength }}
        </div>
      </v-card-title>

      <v-card-text class="c-text">
        {{ $t('quiz.results') }}
      </v-card-text>

      <!-- actions -->
      <v-card-actions class="c-actions py-0">
        <v-btn color="primary" @click="$emit('review')">
          {{ $t('quiz.action.review') }}
        </v-btn>
        <v-btn v-if="quiz.reference" class="ml-4" color="primary" @click="$emit('learn')">
          {{ $t('quiz.action.learn') }}
        </v-btn>
        <v-btn class="ml-4" color="primary" @click="$emit('retake')">
          {{ $t('quiz.action.retake') }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- epilog -->
    <QuizEpilogueCard
      v-if="hasEpilogue"
      class="mb-4"
      :quiz="quiz"
    />

    <!-- article source -->
    <QuizSourceCard
      v-if="source"
      :source="source"
    />

    <!-- references -->
    <QuizReferencesCard
      v-if="references.length > 0"
      :references="references"
    />
  </div>
</template>

<script>
import { quizService } from '@/services/quizService.js'
import QuizEpilogueCard from '@/components/quiz/QuizEpilogueCard'
import QuizReferencesCard from '@/components/quiz/QuizReferencesCard'
import QuizSourceCard from '@/components/quiz/QuizSourceCard'

export default {
  name: 'QuizResultCard',

  components: {
    QuizEpilogueCard,
    QuizReferencesCard,
    QuizSourceCard
  },

  props: {
    quiz: {
      type: Object,
      required: true
    },

    source: {
      type: Object,
      required: false,
      default: null
    },

    startDate: {
      type: Number,
      required: false,
      default: Date.now()
    },

    references: {
      type: Array,
      required: false,
      default: () => []
    },

    responses: {
      type: Array,
      required: true
    },

    submit: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data: function () {
    return {
      score: {}
    }
  },

  computed: {
    passingGrade() {
      return this.quiz.pass || this.quizLength * 0.5
    },

    percentageScore() {
      return (this.score / this.quizLength) * 100
    },

    quizLength() {
      return this.quiz.questions.length
    },

    hasEpilogue() {
      return this.quiz.epilogue && this.quiz.epilogue.length > 0
    }
  },

  created: function () {
    const quizResponses = quizService.generateResponses(this.quiz, this.responses)
    this.score = quizService.calculateScore(quizResponses)
    if (this.submit) {
      this.postResults(quizResponses)
    }
  },

  methods: {
    formattedScore() {
      return this.score.toFixed(2).replace(/[.,]00$/, '')
    },

    postResults(quizResponses) {
      const startDate = this.startDate
      const finishDate = Date.now()

      const user = {
        name: this.$auth.getUserDisplayName(),
        email: this.$auth.getUserEmail()
      }

      quizService.postResults({
        startDate,
        finishDate,
        quiz: {
          slug: this.quiz.slug,
          title: this.quiz.title,
          questions: this.quiz.questions.map((q) => ({
            question: {
              query: q.query
            }
          }))
        },
        user,
        quizResponses,
        score: this.score
      })
    }
  }
}
</script>

<style lang="css" scoped>
.c-result-card {
  text-align: center;
  width: 100%;
}

.c-text {
  font-size: 20px;
}

.c-actions {
  display: flex;
  justify-content: center;
}
</style>
